import styled from 'styled-components'

/** Véu sobre o mapa enquanto nenhum tipo de análise está selecionado. */
export const ContainerOverlayAnalise = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  gap: 10px;
  background: rgba(0, 0, 0, 0.47);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  z-index: 10;
  padding: 20px;
`
